import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';

const AuthImage = ({ src, alt, ...props }) => {
  const [imageSrc, setImageSrc] = useState('');
  const authToken = useSelector(state => state.authentication.user?.authToken);
  const isProtectedImage = Boolean(
    src &&
    authToken &&
    /^https?:\/\//i.test(src)
  );

  useEffect(() => {
    let isActive = true;
    let objectUrl;

    if (!isProtectedImage) {
      setImageSrc(src || '');
      return undefined;
    }

    // Do not put a protected URL directly in <img>. That would trigger a
    // second, unauthenticated browser request alongside this authorized one.
    setImageSrc('');

    axios({
      url: src,
      method: 'GET',
      responseType: 'blob',
      headers: {
        'Authorization': `Bearer ${authToken}`
      }
    })
    .then(response => {
      if (!isActive) return;

      objectUrl = window.URL.createObjectURL(new Blob([response.data]));
      setImageSrc(objectUrl);
    })
    .catch(error => {
      if (!isActive) return;

      const status = error.response?.status;
      if (status !== 401 && status !== 403) {
        console.error('Error loading image:', error);
      }
    });

    return () => {
      isActive = false;
      if (objectUrl) {
        window.URL.revokeObjectURL(objectUrl);
      }
    };
  }, [src, authToken, isProtectedImage]);

  return (
    <img src={imageSrc || undefined} alt={alt} {...props} />
  );
};

export default AuthImage;
